import { api } from '../../../services/api/apiClient';
import type { Paginated, Query } from '../../../types/api';
import type { StockAdjustInput, StockMovement } from '../types/stockTypes';

export const stockService = {
  movements: (query: Query) => api.get<Paginated<StockMovement>>('/stock/movements', query),
  adjust: (body: StockAdjustInput) => api.post('/stock/adjust', body).then((r) => r.data),
  /** Stock value and low-stock counts. */
  summary: () => api.get('/reports/stock-summary').then((r) => r.data),
};
